// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"page_wrapper__SEiw6","content":"page_content__2BF-0"};